import actionTypes from 'app/actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TIERS_DICTIONARY_SUCCESS: {
      return { ...action.dictionary };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/tiers-dictionary.js